import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import GroheFiltersValues from "../../grohe/groheNavigation/groheFilters/groheFiltersValues";
import {setSelectedFilters} from "../../../../actions/actionFunctions";
import {getFeatureGroupFilters} from "../../../../misc/filtersFunctions";
import MaterialSpinner from "../../../ui/materialSpinner";
import GroheFiltersSearchInputAsync from "../../grohe/groheNavigation/groheFilters/groheFiltersSearchInputAsync";
import ShopCategoryAsideProductGroupsFilter from "./shopCategoryAsideProductGroupsFilter";


const ShopCategoryAside = (props) => {

  const {featureGroup, isMobile, shopNavItems, multipleGroups} = props;

  const availableFilters = !featureGroup.allFeaturesReceived ? [] : getFeatureGroupFilters(featureGroup, shopNavItems);
  // console.log("availableFilters", availableFilters);

  if (isMobile) {
    return null
  }

  return (
    <div className="shop-aside">
      <GroheFiltersSearchInputAsync propsFeatureGroup={featureGroup} shouldSearchInAllGroups={true} />
      <ul className="grohe-filters__list u-m-0 u-p-0 text-left">
        {multipleGroups
          ? <ShopCategoryAsideProductGroupsFilter shopNavItems={shopNavItems}/>
          : null}
        {availableFilters.map(availableFilter => {
          return (
            <li className="lk-info__list-item" key={availableFilter.id}>
              <div className="grohe-filters__list-item-header">
                <span className="lk-info__header-title">
                  {availableFilter.filterGroupName}
                  {availableFilter.selectedFiltersLength ? ` (${availableFilter.selectedFiltersLength})` : null}
                </span>
                {featureGroup.filtersReceived || featureGroup.realFeaturesReceived ? null : <MaterialSpinner size={20}/>}
              </div>
              <div className="lk-info__content">
                <GroheFiltersValues availableFilter={availableFilter} featureGroup={featureGroup}/>
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
};

ShopCategoryAside.propTypes = {
  shopNavItems: PropTypes.array,
  multipleGroups: PropTypes.bool,
}

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {selectedFilters} = store.filterState;

  return {
    isMobile,
    selectedFilters,
  };
};

const mapDispatchToProps = {
  setSelectedFilters,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShopCategoryAside)
